import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',fontFamily:'Georgia,serif',background:'#faf8f5',color:'#2c2418'}}>
          <div style={{textAlign:'center',maxWidth:400,padding:'32px 24px'}}>
            <div style={{fontSize:40,marginBottom:16}}>🃏</div>
            <h2 style={{fontSize:20,fontWeight:700,marginBottom:12}}>Something went wrong.</h2>
            <p style={{fontSize:15,lineHeight:1.6,color:'#5a4a38'}}>Please refresh the page — your progress has been saved.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
